import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export default class ProjectTestimonies {
  constructor() {
    this.init();
  }

  init() {
    if (document.querySelectorAll('.testimonies').length > 0) {
      const isLanding = document.querySelector('.testimonies').classList.contains('landing');
      const isRedesign = document.querySelector('.testimonies').classList.contains('redesign');

      const loop = isRedesign;
      const slidesPerView = isLanding ? 2 : 1;
      const autoplayDelay = isLanding ? 5000 : 2000;

      Swiper.use([Navigation, Pagination, Autoplay]);
      new Swiper('.testimonies', {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        breakpoints: {
          1280: {
            slidesPerView: slidesPerView,
            spaceBetween: 40
          }
        },
        preloadImages: false,
        spaceBetween: isLanding ? 40 : 0,
        pagination: {
				  el: '.testimonies .swiper-pagination',
				  clickable: true
        },
        navigation: {
				  nextEl: '.testimonies-next',
				  prevEl: '.testimonies-prev'
        },
        autoplay: {
          delay: autoplayDelay,
          pauseOnMouseEnter: true
        },
        loop: loop
      });
    }
  }
}
